import React, { useEffect, useRef, useState } from 'react'
import {
  RouterProps,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import './Index.scss'
import { Header, Drag, Settings, Login } from '../components'
import { bindEvent } from '../modules/bindEvent'

import { useTranslation } from 'react-i18next'
import { Debounce, deepCopy, NyaNyaWasm } from '@nyanyajs/utils'
import { v5 as uuidv5, v4 as uuidv4 } from 'uuid'

import { api } from '../modules/http/api'

import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  methods,
  notesSlice,
  storageSlice,
  configSlice,
  userSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { createRouter } from '../modules/electron/router'
import { client } from '../store/nsocketio'
import { NoteItem } from '../store/notes/typings'
import { alert, snackbar } from '@saki-ui/core'
import { Query } from '../modules/methods'
import axios from 'axios'
import VerifyAccountComponent from '../components/VerifyAccount'
import AsideContentComponent from '../components/AsideContent'
import FindInAppModal from '../components/FindInApp'
import { SakiInit, SakiI18n } from '../components/saki-ui-react/components'
import { SakiuiEventListener } from '../components/saki-ui-react/types/store/config'
import { initI18n, resources } from '../modules/i18n/i18n'
import { setSakiuiI18n } from '../store/config'
import NoteModalComponent from '../components/NoteModal'
import { sakisso } from '../config'

// import '../modules/webAssembly/dist/wasm_exec.js'
// import '../modules/webAssembly/wasmTypes.d.ts'

const IndexLayout = ({ children }: RouterProps) => {
  const [debounce] = useState(new Debounce())
  const [getRemoteDataDebounce] = useState(new Debounce())
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const [openSettingModal, setOpenSettingModal] = useState(false)
  // const [openSettingType, setOpenSettingType] = useState('')

  const nsocketio = useSelector((state: RootState) => state.nsocketio)
  const appearance = useSelector((state: RootState) => state.appearance)
  const config = useSelector((state: RootState) => state.config)
  const notes = useSelector((state: RootState) => state.notes)

  const appStatus = useSelector((state: RootState) => state.config.status)
  const user = useSelector((state: RootState) => state.user)

  const [hideLoading, setHideLoading] = useState(false)
  const [loadProgressBar, setLoadProgressBar] = useState(false)
  const [progressBar, setProgressBar] = useState(0.01)

  const history = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    debounce.increase(() => {
      initNyaNyaWasm()

      dispatch(methods.sso.Init()).unwrap()
      dispatch(methods.config.Init()).unwrap()
      dispatch(methods.user.Init()).unwrap()
      dispatch(methods.appearance.Init()).unwrap()

      dispatch(methods.notes.Init())
      dispatch(methods.notes.GetLocalData())

      createRouter()

      // console.log('config.deviceType getDeviceType', config)
    }, 50)

    // setTimeout(() => {
    // 	setOpenSettingModal(true)
    // }, 1000)
    // store.dispatch(storageSlice.actions.init())
  }, [])

  useEffect(() => {
    console.log(
      'config.status.nativeThemeChange',
      config.status.electronRouterInitStatus
    )
    config.status.electronRouterInitStatus &&
      dispatch(methods.appearance.Init()).unwrap()
  }, [config.status.electronRouterInitStatus])

  // useEffect(() => {
  // 	// if (!config.networkStatus) {
  // 	// 	dispatch(userSlice.actions.setInit(false))
  // 	// }
  // 	if (config.networkStatus && notes.isInit) {
  // 		dispatch(methods.user.Init()).unwrap()
  // 	}
  // }, [config.networkStatus])

  useEffect(() => {
    // console.log('监听同步开启了', config.deviceType)
    let routePath = location.pathname

    // if (window.location.origin === 'file://') {
    // 	routePath = location.hash
    // }
    console.log(
      '---location.pathname',
      location,
      window.location
      // location.hash,
      // routePath,
      // params.get('route'),
      // location.pathname,

      // routePath === '/' ||
      // 	routePath === '/m' ||
      // 	routePath === '/m/n' ||
      // 	routePath === '/m/c' ||
      // 	routePath === '/m/p'
    )

    // route

    if (!notes.isInit) return
    if (
      config.deviceType &&
      (routePath === '/' ||
        routePath === '/m' ||
        routePath === '/m/n' ||
        routePath === '/m/c' ||
        routePath === '/m/p')
    ) {
      switch (config.deviceType) {
        case 'Mobile':
          //  nid=54fcccd1-189a-5a57-8133-3aac82d6e3e8
          // cid = abb1662a - 9863 - 54ff - a651 - f24e79c32212
          // pid = f9db9ffc - a6bf - 581f - b4fa - 8fd5992b4655
          console.log('切换至Mobile？', location.search)

          dispatch(
            notesSlice.actions.selectNote({
              id: searchParams.get('nid') || notes.noteId || '',
            })
          )
          dispatch(
            notesSlice.actions.selectCategory({
              id: searchParams.get('cid') || notes.categoryId || '',
            })
          )
          dispatch(
            notesSlice.actions.selectPage({
              id: searchParams.get('pid') || notes.pageId || '',
            })
          )

          if (routePath === '/') {
            history?.(
              Query(
                notes.noteId && notes.noteId !== 'none'
                  ? notes.categoryId && notes.categoryId !== 'none'
                    ? notes.pageId && notes.pageId !== 'none'
                      ? '/m/p'
                      : '/m/c'
                    : '/m/n'
                  : '/m',
                {
                  nid: (notes.noteId !== 'none' && notes.noteId) || '',
                  cid: (notes.categoryId !== 'none' && notes.categoryId) || '',
                  pid: (notes.pageId !== 'none' && notes.pageId) || '',
                },
                searchParams
              ),
              {
                replace: true,
              }
            )
          }

          break

        default:
          console.log('切换至PC？', searchParams.get('cid'))

          history?.(Query('/', {}, searchParams), {
            replace: true,
          })
          break
      }
    }
  }, [notes.isInit, config.deviceType])

  // useEffect(() => {
  // 	// console.log('监听同步开启了', notes.isInit, config.sync)
  // 	if (config.sync && user.isLogin && notes.isInit) {
  // 		console.log('监听同步开启了')
  // 		dispatch(methods.notes.GetRemoteData()).unwrap()
  // 	}
  // }, [config.sync])

  useEffect(() => {
    console.log('nsocketio.status', nsocketio.status)
    if (
      nsocketio.status === 'success' &&
      user.isInit &&
      user.isLogin &&
      notes.isInit &&
      config.sync &&
      (location.pathname === '/' || location.pathname.indexOf('/m') === 0)
    ) {
      getRemoteDataDebounce.increase(() => {
        dispatch(methods.notes.GetRemoteData()).unwrap()
      }, 300)
    }
  }, [nsocketio.status, user.isInit, user.isLogin, notes.isInit, config.sync])

  useEffect(() => {
    if (user.isInit) {
      progressBar < 1 &&
        setProgressBar(progressBar + 0.2 >= 1 ? 1 : progressBar + 0.2)
    }
    console.log(
      'nsocketio.Init',
      location.pathname,
      user.isInit,
      user.isLogin,
      location.pathname === '/' || location.pathname.indexOf('/m') === 0
    )
    if (
      user.isInit &&
      user.isLogin &&
      (location.pathname === '/' || location.pathname.indexOf('/m') === 0)
    ) {
      dispatch(methods.nsocketio.Init()).unwrap()
    } else {
      dispatch(methods.nsocketio.Close()).unwrap()
    }
  }, [user.isInit, user.isLogin])

  // 清理无用数据
  // const cleanListDataDeb = useRef(new Debounce())
  // useEffect(() => {
  //   cleanListDataDeb.current.increase(() => {
  //     dispatch(notesSlice.actions.cleanNote())
  //   }, 300)
  // }, [notes.list, dispatch])

  useEffect(() => {
    if (
      appStatus.sakiUIInitStatus &&
      appStatus.noteInitStatus &&
      loadProgressBar &&
      user.isInit
    ) {
      console.log('progressBar', progressBar)
      progressBar < 1 &&
        setTimeout(() => {
          console.log('progressBar', progressBar)
          setProgressBar(1)
        }, 500)
    }
    // console.log("progressBar",progressBar)
  }, [
    user.isInit,
    appStatus.noteInitStatus,
    appStatus.syncStatus,
    loadProgressBar,
    appStatus.sakiUIInitStatus,
  ])

  // useEffect(() => {
  // 	if (config.contextMenuConfig.visible && config.contextMenuEl) {
  // 		config.contextMenuEl?.show({
  // 			x: config.contextMenuConfig.x,
  // 			y: config.contextMenuConfig.y,
  // 			label: config.contextMenuConfig.label,
  // 		})
  // 		return
  // 	}
  // 	dispatch(configSlice.actions.setContextMenuEl(undefined))
  // }, [config.contextMenuConfig.visible, config.contextMenuEl])

  const initNyaNyaWasm = async () => {
    const res = await axios({
      method: 'GET',
      url: 'https://saass.aiiko.club/api/v1/share?path=/NyaNyaJS/1.0.0&sid=EWmdAO1GBw',
    })
    console.log('initNyaNyaWasm', res?.data?.data?.list)
    if (res?.data?.data?.list?.length) {
      res?.data?.data?.list.forEach((v: any) => {
        console.log(v)
        if (v.fileName === 'wasm_exec.js') {
          NyaNyaWasm.setCoreJsPath(v.urls.domainUrl + v.urls.shortUrl)
        }
        if (
          v.fileName === 'nyanyajs-utils-wasm.wasm' ||
          v.fileName === 'wasm_exec.js'
        ) {
          NyaNyaWasm.setWasmPath(v.urls.domainUrl + v.urls.shortUrl)
        }
      })
    }
  }

  return (
    <div className="index-layout">
      <saki-base-style></saki-base-style>
      <Login />
      <VerifyAccountComponent></VerifyAccountComponent>
      <SakiInit
        onMounted={async (e) => {
          console.log('SakiInit', e.target)
          const sakiuiEventListener: SakiuiEventListener =
            await e.target.getSakiuiEventListener()
          console.log('sakiuiEventListener', sakiuiEventListener)

          console.log('saki', (window as any)?.sakiui?.i18n)

          sakiuiEventListener.on('loadI18n', async (i18n) => {
            console.log('loadI18n saki', i18n)
            setSakiuiI18n(i18n)
          })

          // setTimeout(() => {
          // 	const i18n = (window as any).sakiui?.i18n
          // 	console.log('i18n', i18n)

          // 	snackbar({
          // 		message: i18n.t('loginSuccessfully', {
          // 			ns: 'prompt',
          // 		}),
          // 		horizontal: 'center',
          // 		vertical: 'top',
          // 		// autoHideDuration: 2000,
          // 		closeIcon: true,
          // 	}).open()
          // }, 2000)

          store.dispatch(
            configSlice.actions.setStatus({
              type: 'sakiUIInitStatus',
              v: true,
            })
          )
          store.dispatch(methods.config.getDeviceType())
        }}
        debug
      ></SakiInit>
      {user.isInit && !user.isLogin ? (
        <saki-sso-init
          ref={bindEvent({
            login: (e: any) => {
              console.log('saki-sso-init login', e)
              store.dispatch(
                userSlice.actions.login({
                  token: e.detail.token,
                  deviceId: e.detail.deviceId,
                  userInfo: e.detail.userInfo,
                })
              )
              // e?.target?.loggedIn()
            },
          })}
          url={sakisso.clientUrl}
        ></saki-sso-init>
      ) : (
        ''
      )}
      <SakiI18n
        onMounted={async (e) => {
          console.log('SakiI18n', e.target)
          const r = await e.target.getResources()
          console.log('SakiI18n', r)
          initI18n(r)
        }}
        language={config.language}
        lang={i18n.language}
        languages={config.languages}
        resources={resources as any}
      ></SakiI18n>
      <div
        onTransitionEnd={() => {
          console.log('onTransitionEnd')
          // setHideLoading(true)
        }}
        className={
          'il-loading active ' +
          // (!(appStatus.noteInitStatus && appStatus.sakiUIInitStatus)
          // 	? 'active '
          // 	: '') +
          (hideLoading ? 'hide' : '')
        }
      >
        {/* <div className='loading-animation'></div>
				<div className='loading-name'>
					{t('appTitle', {
						ns: 'common',
					})}
				</div> */}
        <div className="loading-logo">
          <img
            src={config.origin + '/logo192.png'}
            alt=""
            crossOrigin="anonymous"
          />
        </div>
        {/* <div>progressBar, {progressBar}</div> */}
        <div className="loading-progress-bar">
          <saki-linear-progress-bar
            ref={bindEvent({
              loaded: () => {
                console.log('progress-bar', progressBar)
                setProgressBar(0)
                setTimeout(() => {
                  progressBar < 1 &&
                    setProgressBar(
                      progressBar + 0.2 >= 1 ? 1 : progressBar + 0.2
                    )
                }, 0)
                setLoadProgressBar(true)
              },
              transitionEnd: (e: CustomEvent) => {
                console.log('progress-bar', e)
                if (e.detail === 1) {
                  const el: HTMLDivElement | null =
                    document.querySelector('.il-loading')
                  if (el) {
                    const animation = el.animate(
                      [
                        {
                          opacity: 1,
                        },
                        {
                          opacity: 0,
                        },
                      ],
                      {
                        duration: 500,
                        iterations: 1,
                      }
                    )
                    animation.onfinish = () => {
                      el.style.display = 'none'
                      setHideLoading(true)
                    }
                  }
                }
              },
            })}
            max-width="280px"
            transition="width 1s"
            width="100%"
            height="10px"
            progress={progressBar}
            border-radius="5px"
          ></saki-linear-progress-bar>
        </div>
      </div>
      <Header
        onSettings={(type: string) => {
          console.log('onSettings', type)
          // setOpenSettingType(type)
          store.dispatch(configSlice.actions.setSettingType(type))
          setOpenSettingModal(true)
        }}
      />
      {nsocketio.status !== 'success' &&
      user.token &&
      config.deviceType === 'Mobile' ? (
        <div className="il-connection-error">
          <saki-animation-loading
            type="rotateEaseInOut"
            width="20px"
            height="20px"
            border="3px"
            border-color="var(--default-color)"
          />
          <span
            style={{
              color: '#555',
            }}
          >
            {t('connecting', {
              ns: 'common',
            })}
          </span>
        </div>
      ) : (
        ''
      )}
      <div className="il-main">{children}</div>
      <Settings
        visible={openSettingModal}
        // type={openSettingType}
        onClose={() => {
          setOpenSettingModal(false)
        }}
      />
      <Drag></Drag>
      <AsideContentComponent />
      <FindInAppModal />
      <NoteModalComponent />
    </div>
  )
}

export default IndexLayout
